<form>
  <div class="mt-3">
    <!-- Group Header -->
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        @if (level > 0) {
          <div
            class="level-spacer">
            &nbsp;
          </div>
        }
        <div style="font-weight: 600"
          class="mr-3">
          {{ 'FILTERS.MATCH' | translate }}
        </div>
        <div class="select is-medium mr-3">
          <select style="min-width: 80px; margin-left: -4px"
            [(ngModel)]="_filterGroup.groupType"
            [id]="_filterGroup.uId + '_GroupType'"
            [name]="_filterGroup.uId + '_GroupType'">
            <option [ngValue]="1">{{ 'FILTERS.ALL' | translate }}</option>
            <option [ngValue]="2">{{ 'FILTERS.ANY' | translate }}</option>
          </select>
        </div>
        @if (hasChildGroups(_filterGroup)) {
          <div>
            {{ 'FILTERS.OF-THE-FOLLOWING-ARE-TRUE' | translate }}
          </div>
        }
        @if (!hasChildGroups(_filterGroup)) {
          <div
            class="mr-3">
            {{ 'FILTERS.FROM' | translate }}
          </div>
        }
        @if (!hasChildGroups(_filterGroup)) {
          <div class="select is-medium mr-3" style="font-weight: 600">
            {{ fromDataset?.name }}
            <!--          <select style="font-weight: 600"
            [disabled]="true"
            [id]="_filterGroup.uId + '_FromDataset'"
            [name]="_filterGroup.uId + '_FromDataset'"
            [(ngModel)]="_filterGroup.fromDatasetUId"
            (change)="fromDatasetChanged()">
            <option style="font-weight: 600" [ngValue]="datasets[0].uId">{{ datasets[0].name }}</option>
            <option style="font-weight: 600" [ngValue]="datasets[1].uId">{{ datasets[1].name }}</option>
          </select> -->
        </div>
      }
      @if (!hasChildGroups(_filterGroup)) {
        <div class="select is-medium mr-3">
          <select style="min-width:200px"
            [id]="_filterGroup.uId + '_DatasetOrValue'"
            [name]="_filterGroup.uId + '_DatasetOrValue'"
            [(ngModel)]="toDatasetOrValue"
            (change)="toDatasetChanged()">
            <option [ngValue]="0">{{ 'FILTERS.TO-VALUE' | translate }}</option>
            <option [ngValue]="1">{{ 'FILTERS.TO-DATASET' | translate }}</option>
          </select>
        </div>
      }
      @if (!hasChildGroups(_filterGroup) && toDatasetOrValue === 1) {
        <div style="font-weight: 600">
          {{ toDataset?.name }}
        </div>
      }
    </div>
    @if (level !== 0) {
      <div>
        <button
          (click)="deleteFilterGroupClick()"
          class="button is-ghost is-large ml-1">
          <i class="icon icon-remove_outline"></i>
        </button>
      </div>
    }
  </div>

  <!-- Filters -->
  @for (filter of _filterGroup?.filters; track filter.uId; let i = $index) {
    <div
      fxLayout="row"
      fxLayoutAlign="start top"
      class="mt-2">
      @if (level > 0) {
        <div class="level-spacer">&nbsp;</div>
      }
      <div
        class="mr-3 level-0 filter-item">
        {{ i + 1 }}
      </div>
      @if (toDatasetOrValue === 0) {
        <topo-link-filter-item
          [lookupTargetSchemaFields]="lookupTargetSchemaFields"
          [filterGroup]="_filterGroup"
          [filter]="filter"
          [dataset]="fromDataset"
          [unitsConversionValue]="unitsConversionValue"
          (filterChanged)="onFilterChanged($event)"
        style="width: 100%"></topo-link-filter-item>
      }
      @if (toDatasetOrValue === 1) {
        <topo-link-filter-dataset-item
          [lookupTargetSchemaFields]="lookupTargetSchemaFields"
          [targetDataset]="toDataset"
          [filterGroup]="_filterGroup"
          [filter]="filter"
          [dataset]="fromDataset"
          [unitsConversionValue]="unitsConversionValue"
          (filterChanged)="onFilterChanged($event)"
        style="width: 100%"></topo-link-filter-dataset-item>
      }
    </div>
  }
</div>
</form>

<!-- Child Filter Groups -->
@for (childFilterGroup of _filterGroup?.filterGroups; track childFilterGroup.uId) {
  <div fxLayout="row">
    @if (level > 0) {
      <div class="level-spacer">&nbsp;</div>
    }
    <topo-link-filter-group
      [level]="nextLevel"
      [parentFilterGroup]="_filterGroup"
      [lookupTargetSchemaFields]="lookupTargetSchemaFields"
      [datasets]="datasets"
      [filterGroup]="childFilterGroup"
    style="width: 100%"></topo-link-filter-group>
  </div>
}

<div
  fxLayout="row"
  class="mt-3 mb-4">
  @if (level === 0) {
    <div title="{{ 'FILTERS.ADD-FILTER' | translate }}"
      class="mr-3 level-0 add-filter-button"
      (click)="addFilterClick()">
      <i class="icon add-icon icon-add_plus_zoom-in"></i>
    </div>
    <div title="{{ 'FILTERS.ADD-FILTER-GROUP' | translate }}"
      class="mr-3 level-1 add-group-button"
      (click)="addFilterGroupClick()">
      <i class="icon icon-group-rows"></i>
    </div>
  }

  @if (level === 1) {
    <div class="level-spacer">&nbsp;</div>
    <div title="{{ 'FILTERS.ADD-FILTER' | translate }}"
      class="mr-3 level-1 add-filter-button"
      (click)="addFilterClick()">
      <i class="icon add-icon icon-add_plus_zoom-in"></i>
    </div>
    <div title="{{ 'FILTERS.ADD-FILTER-GROUP' | translate }}"
      class="mr-3 level-2 add-group-button"
      (click)="addFilterGroupClick()">
      <i class="icon icon-group-rows"></i>
    </div>
  }
  @if (level === 2) {
    <div class="level-spacer">&nbsp;</div>
    <div title="{{ 'FILTERS.ADD-FILTER' | translate }}"
      class="mr-3 level-2 add-filter-button"
      (click)="addFilterClick()">
      <i class="icon add-icon icon-add_plus_zoom-in"></i>
    </div>
  }
</div>


